import glamorous from 'glamorous';
import React from 'react';
import { Categories } from 'module/Model/Categories';
import { CategoriesSelector } from 'module/Redux/Categories';
import { Colors, LocalizedText, MzImageDisplay, NavProvider, Sizes, WishHandler } from 'module/View/Common';
import { ColumnsUtils, createPureComponent, Invariant } from 'module/Common';
import { connect } from 'react-redux';
import { ContentImagesLinks } from 'module/Model/Content';
import { RouteType } from 'module/Model/Routes';
import { SizeForRatio } from 'module/Model/Size';
import { State } from 'module/Redux';
import { Wish } from 'module/Model/Wish';

const Wrapper = glamorous.div({
  display: 'flex',
  verticalAlign: 'top',
  alignItems: 'flex-start',
  pointerEvents: 'all',
});

type ColumnProps = {
  rightSpace?: number;
  leftSpace?: number;
  width: number;
};

const Column = glamorous.div<ColumnProps>(({ rightSpace = 0, leftSpace = 0, width }) => ({
  marginRight: rightSpace,
  marginLeft: leftSpace,
  width,
  position: 'relative',
}));

const LinkWrapper = glamorous.a({});

const HoverTile = glamorous.div({
  background: Colors.midnightBlue,
  opacity: 0,
  transitionDuration: '0.3s',
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  color: 'white',
  padding: '1rem',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: 2,
  ':hover': {
    opacity: 1,
  },
  cursor: 'pointer',
});

type OwnProps = {
  item: ContentImagesLinks;
  itemIndex: number;
  availableWidth: number;
  isCover: boolean;
  cols: ColumnsUtils.ColumnsResult;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

type StateProps = {
  categoriesWish: Wish<Categories>;
};

const mapStateToProps = (s: State): StateProps => ({
  categoriesWish: CategoriesSelector.selectAll(s),
});

type Props = OwnProps & StateProps;

const CategoriesHandler = WishHandler.create<Categories>();

const ImagesLinksComp = createPureComponent<Props>(
  'ImagesLinks',
  ({ item, itemIndex, availableWidth, cols, categoriesWish, imageReady, waitForImage }) => {
    const nbOfColumns = item.elements.length;
    const width = item.fullWidth ? availableWidth : cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
    const localCols = ColumnsUtils.getColumns({
      availableWidth: width,
      nbOfColumns,
      spaceBetween: Sizes.smallGutter,
      spaceAround: [0, Sizes.gutter],
    });

    return (
      <CategoriesHandler
        wish={categoriesWish}
        handleResolved={categories => (
          <Wrapper>
            {item.elements.map((elem, index) => {
              const imgId = elem.image.id.toString();
              const isLast = index === item.elements.length - 1;
              const img = (
                <MzImageDisplay
                  annim={true}
                  image={elem.image}
                  size={SizeForRatio.create(localCols.size(1), 'auto')}
                  onLoad={() => imageReady(imgId)}
                  onMount={() => waitForImage(imgId)}
                />
              );
              const isLink = elem.categoryId !== false;
              const cat = elem.categoryId ? Categories.findById(categories, Invariant.number(elem.categoryId)) : null;
              return (
                <Column key={index} rightSpace={isLast ? 0 : Sizes.smallGutter} leftSpace={0} width={localCols.size(1)}>
                  {isLink ? (
                    <NavProvider
                      routeType={RouteType.Category}
                      routeId={Invariant.number(elem.categoryId)}
                      requestNavigation={true}
                    >
                      {params => (
                        <LinkWrapper {...params.getAnchorProps()}>
                          {img}
                          <HoverTile>{cat && <LocalizedText content={cat.name} />}</HoverTile>
                        </LinkWrapper>
                      )}
                    </NavProvider>
                  ) : (
                    img
                  )}
                </Column>
              );
            })}
          </Wrapper>
        )}
      />
    );
  }
);

export const ImagesLinks = connect(mapStateToProps)(ImagesLinksComp);



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/ImagesLinks.tsx